import { Component } from '@angular/core';

import { SessionService } from '@app/core/services/session.service';

import { Dealer } from '@app/core/models/dealer.model';

@Component({
	selector: 'cng-legal-footer-links',
	templateUrl: './footer-links.component.html',
	styleUrls: ['../legal-info.less', './footer-links.component.less']
})

export class ConfigureLegalFooterLinksComponent {
	
	dealer: Dealer = this.session_service.getDealer();
	
	/**
	 * Constructs class and injects dependencies.
	 *
	 * @param {SessionService} session_service
	 */
	constructor(
		private session_service: SessionService
	) {
	}
	
}
